module.exports = __webpack_public_path__ + "static/plancton-52518b8c3a992ecad1cf6d7444633210.jpg";